import React from 'react';

export default function ResizeBorder(props) {
    return (
        <div className="resize-borders">
            <div className="resize-borders-border resize-top"/>
            <div className="resize-borders-border resize-right"/>
            <div className="resize-borders-border resize-bottom"/>
            <div className="resize-borders-border resize-left"/>

            <div className="resize-borders-corner resize-left resize-top"/>
            <div className="resize-borders-corner resize-right resize-top"/>
            <div className="resize-borders-corner resize-right resize-bottom"/>
            <div className="resize-borders-corner resize-left resize-bottom"/>
        </div>
    );
}